export default __webpack_public_path__ + "static/media/developer.a269b8c9.svg";